// src/components/PP2Exams.js
import React from 'react';
import ExamsList from './ExamsListPerYear';


const Grade5Examinations = ({ isLoggedIn, clearToken }) => {
    const items = [
        { name: 'GRADE 5 EXAMINATIONS 2026 ', year: 2026, bgColor: 'rgba(0, 0, 0, 0.2)', textColor: 'rgb(0, 0, 0)', path: "primary", value: "grade5/examinations" },
        { name: 'GRADE 5 EXAMINATIONS 2025 ', year: 2025, bgColor: 'rgba(0, 0, 0, 0.1)', textColor: 'rgb(0, 0, 0)', path: "primary", value: "grade5/examinations" },
 
    ];

    return (
        <>
       
        <ExamsList           
            heading="GRADE 5 EXAMINATIONS"
            items={items}
            navigateTo="/grade5/examinations/downloads"
        />
        </>
    );
};

export default Grade5Examinations;
